/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Room_Temperatures_To_Frost_FreeInputs */

/** @type {(inputs: Room_Temperatures_To_Frost_FreeInputs) => LocalizedString} */
const fr_room_temperatures_to_frost_free = () => /** @type {LocalizedString} */ ('room_temperatures_to_frost_free')

/**
* | output |
* | --- |
* | "Frost-free temperature" |
*
* @param {Room_Temperatures_To_Frost_FreeInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const room_temperatures_to_frost_free = /** @type {((inputs?: Room_Temperatures_To_Frost_FreeInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Room_Temperatures_To_Frost_FreeInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Frost-free temperature")
	return fr_room_temperatures_to_frost_free(inputs)
});